import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GuestShell } from './GuestShell';
import { GUEST_PRODUCT_PAGES } from './product-registry';
import type { LazyGuestPage } from './guest-types';

// Isolated from the app's global queryClient — avoids cache cross-contamination, and the guest
// shell never retries a failed request against an unauthenticated endpoint (pattern:
// src/pages/Signup/SignupApp.tsx).
const guestQueryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

export interface GuestAppProps {
  /** Overridable for tests/Storybook fixtures; production always uses `GUEST_PRODUCT_PAGES` (empty in P0d). */
  registry?: Readonly<Record<string, LazyGuestPage>>;
}

/** Root for the guest shell: isolated `QueryClient` + the `GuestShell` state machine. */
export function GuestApp({ registry = GUEST_PRODUCT_PAGES }: GuestAppProps) {
  return (
    <QueryClientProvider client={guestQueryClient}>
      <GuestShell registry={registry} />
    </QueryClientProvider>
  );
}
